<div class="headline">
  <span class="mat-h1 m0">Übersicht</span>
</div>
<hr>
<div class="mat-elevation-z8" style="margin: 0.8rem">
  @if (content) {
    <app-markdown-editor [readonly]="true" [content]="content"></app-markdown-editor>
  }
</div>

